export function getHistoryUrl(repositoryId: number) {
  return `/entity/repository/history/${repositoryId}`
}
